<template>
  <div class="w-full pt-32 flex flex-col items-center justify-center">
    <div v-if="isLoading">
      <img
        class="w-20 h-20 animate-spin fill-[#061B44] pt-24"
        src="../assets/icons/loading-loader.svg"
        alt="Loading icon"
      />
    </div>
    <div v-else class="flex flex-col items-center justify-center">
      <svg
        width="120"
        height="120"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-green-400"
      >
        <path
          d="M21.855 10.303c.086.554.145 1.118.145 1.697 0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11c2.348 0 4.518.741 6.304 1.993l-1.421 1.457c-1.408-.913-3.083-1.45-4.883-1.45-4.963 0-9 4.038-9 9s4.037 9 9 9c4.894 0 8.879-3.928 8.99-8.795l1.865-1.902zm-.951-8.136l-9.404 9.639-3.843-3.614-3.095 3.098 6.938 6.71 12.5-12.737-3.096-3.096z"
        />
      </svg>
      <div class="text-3xl text-black font-bold pb-2 pt-4">
        {{ $t("thank-you-for-your-order") }}
      </div>
      <p class="text-xl font-semibold pt-4 text-center">
        {{ $t("your-balance-has-been-charged-for-transcription-services") }}
      </p>
      <p v-if="redirect" class="text-lg font-semibold pt-4 text-center">
        {{
          $t(
            "your-subscription-has-been-successfully-updated-and-is-now-active"
          )
        }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { API_BASE_URL, CAPTUREPAYPALORDER, SECCESSORDER } from "../utils/appConst";
import { useAuthStore } from "../store/auth";
import { useRoute, useRouter } from "vue-router";
import { useUserActivities } from "../store/userActivities";

const successOrderUrl = `${API_BASE_URL}${SECCESSORDER}`;
const capturePaypalUrl = `${API_BASE_URL}${CAPTUREPAYPALORDER}`;
const authStore = useAuthStore();
const activitesStore = useUserActivities();
const route = useRoute();
const router = useRouter();
const isLoading = ref(true);
const redirect = ref(false);

onMounted(async () => {
  await getUserInfo();
  await checkOldRoute();
});

const checkOldRoute = async () => {
  try {
    if (
      activitesStore.beforePay != null &&
      activitesStore.beforePay != "null"
    ) {
      redirect.value = true;
      setTimeout(() => {
        router.push(`/${activitesStore.beforePay}`);
      }, 1000);
    }
  } catch (error) {
    console.error("checkOldRoute", error);
  }
};

const getUserInfo = async () => {
  try {
    if (!route.query.session_id && !route.query.token) {
      router.push({ path: "/" });
      return;
    }
    if (route.query.session_id) {
      await checkStripeOrder();
    } else {
      await checkPaypalOrder();
    }
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const checkStripeOrder = async () => {
  try {
    const response = await fetch(
      `${successOrderUrl}?session_id=${route.query.session_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      }
    );

    if (!response.ok) {
      router.push({ path: "/" });
      return;
    }

    const results = await response.json();
    console.log(results);
    if (results.status == "complete") {
      isLoading.value = false;
    } else {
      router.push({ path: "/" });
      return;
    }
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const checkPaypalOrder = async () => {
  try {
    const response = await fetch(
      `${capturePaypalUrl}/${route.query.token}/capture`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      }
    );

    if (!response.ok) {
      router.push({ path: "/" });
      return;
    }

    const results = await response.json();
    console.log(results);
    if (results.status == "complete") {
      isLoading.value = false;
    } else {
      router.push({ path: "/" });
      return;
    }
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};
</script>
